import React from 'react';
import Container from "../../container";
import { Link } from 'react-router-dom';

const BlogComponent = () => {
    return (
        <>
            <Container headerType={'inner'}>
                <div id="container" >
                    <div id="content_fullHeader">
                        <div className='inPgHeadBlueBg'>
                            <div className="widthfix">
                                <ul className='breadcrumbLink'>
                                    <li className="breadcrumbLink">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumbLink">
                                        Blogs
                                    </li>
                                </ul>
                                <div className='padBot60'></div>
                            </div>
                        </div>
                        <div className="widthfix">
                            <div className='events'>
                                <div className='eventIcol'>
                                    <div className="pgHeadText">Blog Listings</div>
                                    <div className='blog'>
                                        <div className='contentPad20'>
                                            <ul className='contentIIIcol'>
                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg1'></div>
                                                        <div className='blogHead'><Link to="/blog1">The Masterpiece of Financial Engineering: A Deep Dive into Securitization Analytics and Actors</Link></div>
                                                    </div>
                                                </li>
                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg2'></div>
                                                        <div className='blogHead'><Link to="/blog2">The End of "Trust But Verify": Architecting the Self-Healing Web of Mortgage Assurance</Link></div>
                                                    </div>
                                                </li>
                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg3'></div>
                                                        <div className='blogHead'><Link to="/blog3">From Black Box to Glass Box:<br/>Rating Loans in the Age of Verifiable Certainty</Link></div>
                                                    </div>
                                                </li>
                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg4'></div>
                                                        <div className='blogHead'><Link to="/blog4">The Living MBS: <br/>From Static Rating to Dynamic Risk Monitoring</Link></div>
                                                    </div>
                                                </li>
                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg5'></div>
                                                        <div className='blogHead'><Link to="/blog5">The Immutable Mortgage: How Blockchain is Forging the Next Trillion-Dollar Asset Class</Link></div>
                                                    </div>
                                                </li>

                                                <li className='contentIIIcol'>
                                                    <div className='shadowBlk'>
                                                        <div className='blogImg6'></div>
                                                        <div className='blogHead'><Link to="/blog6">The Symphony of Assurance.<br/>Forging a New Architecture for Capital Finance</Link></div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default BlogComponent;